import { useState } from "react";

const LessMoreforInvoice = ({ value = ''}) => {
    const [isExpand, setExpanded] = useState(false);

    const isExpandFun = (val) => {
        setExpanded(!val);
    }
    return (
            <div >
                { value?.length > 160 ? !isExpand ?
                    <>
                        {value.substring(0, 160)}<span style={{ color: "#0e7fe1", cursor: 'pointer' }} onClick={(e) => { e.preventDefault(); isExpandFun(isExpand); }}>...more</span>
                    </>
                    : <>
                        {value} <span style={{ color: "#0e7fe1", cursor: 'pointer' }} onClick={(e) => { e.preventDefault(); isExpandFun(isExpand); }}>...less</span>
                    </>
                    : <span>{value}</span>}
            </div>
    )
}
export default LessMoreforInvoice;